import type { SVGProps } from 'react';

export function HelmetIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.4 12.3V4.8c0-.664-.536-1.2-1.2-1.2h-2.4c-.664 0-1.2.536-1.2 1.2v7.5c0 .499-.401.9-.9.9a.9.9 0 0 1-.9-.9V6.763c0-.696-.695-1.174-1.296-.824C4.006 7.394 2.4 10.1 2.4 13.2v1.4a1 1 0 0 0 1 1h17.2a1 1 0 0 0 1-1v-1.4c-.032-3.063-1.622-5.776-4.1-7.245-.6-.356-1.3.122-1.3.82V12.3c0 .499-.401.9-.9.9a.9.9 0 0 1-.9-.9M2.7 17.4a1.5 1.5 0 1 0 0 3h18.6a1.5 1.5 0 1 0 0-3z" />
    </svg>
  );
}
